import DefaultIcon from './default-icon';
import CodeIcon from './code-icon';
import MenuIcon from './menu-icon';
import PersonIcon from './person-icon';
import TicketIcon from './ticket-icon';
import ToolboxIcon from './toolbox-icon';

export default {
  DefaultIcon,
  CodeIcon,
  MenuIcon,
  PersonIcon,
  TicketIcon,
  ToolboxIcon,
};
